import { useEffect, useState } from 'react';
import { List, ListItemText, ListItemButton } from '@mui/material';
import { useController } from 'react-hook-form';
import { IDistrictViewModel } from 'viewModels';
import { useDistricts } from '../../context/districts';
import { useCourts } from '../../context/courts';
import { Container, MessageContainer } from './styles';
import { slugify } from '../../utils/slugify';

interface DistrictListProps {
  districtState: number;
  disabled?: boolean;
  name: string;
  control: any;
  filterValue: string;
}

export function DistrictList({
  districtState,
  disabled = false,
  name,
  filterValue,
  control,
}: DistrictListProps) {
  const [, setFilter] = useState('');
  const [selectedDistrictId, setSelectedDistrictId] = useState<String>();
  const {
    field: { onChange },
  } = useController({ name, control });
  const { districts } = useDistricts();
  const { setDistrictSelectedId, districtSelectedId } = useCourts();

  const handleSelectDistrict = (district: IDistrictViewModel) => {
    onChange(district.name);
    setDistrictSelectedId(district.id);
    setSelectedDistrictId(district.id);
  };

  const filteredDistricts = districts.filter((district) =>
    slugify(district.name).includes(slugify(filterValue)),
  );

  useEffect(() => {
    if (districtSelectedId !== '') {
      setSelectedDistrictId(districtSelectedId);
    }
  }, [districtSelectedId]);

  useEffect(() => {
    setFilter(filterValue);
    if (filterValue === '') {
      setSelectedDistrictId('');
      onChange('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue]);

  if (!districtState) {
    return <MessageContainer>Selecione um estado para exibir as comarcas</MessageContainer>;
  }

  return (
    <Container>
      <div className="listContainer">
        <List disablePadding>
          {filteredDistricts.map((district) => (
            <ListItemButton
              key={district.id}
              onClick={() => handleSelectDistrict(district)}
              disabled={disabled}
              className={selectedDistrictId === district.id ? 'selected' : ''}>
              <ListItemText primary={district.name} />
            </ListItemButton>
          ))}
        </List>
      </div>
    </Container>
  );
}
